// General notifications: type = events.type, sub-type id = events.values->>'sub-type'
const cameraEventSubTypes = [
    {id: 'lane_departure', icon: 'swerve', name: 'Lane departure'},
    {id: 'collision_warning', icon: 'collision-warning', name: 'Collision warning'},
    {id: 'tailgating', icon: 'attention', name: 'Tailgating'},
    {id: 'driver_distraction', icon: 'driver-distraction', name: 'Driver distraction'},
    {id: 'drowsiness', icon: 'drivers-eyes-closed', name: 'Drowsiness'},
    {id: 'cell_phone', icon: 'talking-on-cell-phone', name: 'Cell phone use'},
    {id: 'smoking', icon: 'smoking', name: 'Smoking'},
    {id: 'no_seat_belt', icon: 'no-safety-belt', name: 'No seat belt'},
    {id: 'traffic_violation', icon: 'sign-violation', name: 'Traffic violation'},
    {id: 'speeding', icon: 'speeding', name: 'Speeding'},
    {id: 'harsh_driving', icon: 'danger-maneuver', name: 'Harsh driving'},
    {id: 'crash', icon: 'accident', name: 'Crash'},
    {id: 'camera_health', icon: 'other', name: 'Camera health'},
    {id: 'driver_button', icon: 'other', name: 'Driver button'},
]

const videoEventTypes = [
    {type: 'camera.event', subTypes: cameraEventSubTypes},
    {type: 'camera.alert'},
]

const otherEventTypes = [
    {type: 'geozone.entry', icon: 'other', name: 'Geozone entry'},
    {type: 'geozone.exit', icon: 'other', name: 'Geozone exit'},
    {type: 'door open', icon: 'cargo-door-open', name: 'Door open'},
    {type: 'door close', icon: 'cargo-door-closed', name: 'Door close'},
    {type: 'BLE connect', icon: 'other', name: 'BLE connect'},
    {type: 'BLE disconnect', icon: 'other', name: 'BLE disconnect'},
    {type: 'alert', icon: 'other', name: 'Reefer alert'},
    {type: 'thermo king', icon: 'other', name: 'Thermo King'},
    {type: 'driving.behavior', icon: 'danger-maneuver', name: 'Driving behavior'},
    {type: 'loaded', icon: 'other', name: 'Loaded'},
    {type: 'unloaded', icon: 'other', name: 'Unloaded'},
    {type: 'tire_alert', icon: 'other', name: 'Tire alert', subTypes: [
        {id: 'tire.pressure.down', name: 'Tire pressure down'},
    ]},
    {type: 'recovery time', icon: 'other', name: 'Recovery time'},
    {type: 'xroute', icon: 'other', name: 'Route events', subTypes: [
        {id: 'route_accepted', name: 'Route accepted'},
        {id: 'navigation.started', name: 'Navigation started'},
        {id: 'navigation.completed', name: 'Navigation completed'},
        {id: 'waypoint.arrived', name: 'Waypoint arrived'},
        {id: 'waypoint.departed', name: 'Waypoint departed'},
        {id: 'route_deviation', name: 'Route deviation'},
        {id: 'unexpected_stop', name: 'Unexpected stop'},
    ]},
]

const consts = {
    default_route: '/units',
    fetchAppProps: {
        dispatches: [
            {name: 'fetchUserSettings', params: {}},
            {name: 'fetchUserFavoritesAndObjects', params: {}},
            {name: 'fetchUnitsIcons', params: {}},
            {name: 'fetchUnitsHwTypesAll', params: {}},
            {name: 'fetchUnitsHwTypesSettings', params: {}},
            {name: 'fetchSmsGatewayTypes', params: {}},
            {name: 'fetchUnitsTypes', params: {}},
            {name: 'fetchUnitsXTypes', params: {}},
            {name: 'fetchChassisTypes', params: {}},
            {name: 'fetchUnitsOfMeasures', params: {}},
            {name: 'fetchGrafanaSettings', params: {}},

            {name: 'fetchAppUser', params: {}},

            {name: 'fetchAppObjects', params: [
                {name: 'fetchUnitsLmsgsAll', params: {withAddress: 1, withSensors: 1}},
                {name: 'fetchVideoStatusesAll', params: {}},
                {name: 'fetchUnitsAll', params: {}},

                {name: 'fetchUnitsGroupsAll', params: {}},

                {name: 'fetchUsersAll', params: {}},
                {name: 'fetchUsersCustomizesAll', params: {}},

                {name: 'fetchGeopointsAll', params: {}},
                {name: 'fetchGeozonesAll', params: {}},

                {name: 'fetchGeopointsGroupsAll', params: {}},
                {name: 'fetchGeozonesGroupsAll', params: {}},
                {name: 'fetchDriversAll', params: {}},
                {name: 'fetchDriversGroupsAll', params: {}},
                {name: 'fetchAppointmentsAll', params: {}},

                {name: 'fetchInsuranceReportsAll', params: {}},

                {name: 'fetchSensorsAll', params: {}},

                //{name: 'fetchAccidentsAll', params: {}},
                // {name: 'fetchNotificationsAll', params: {}},
            ]},

            //{name: 'fetchNotificationsAll', params: {}},
            {name: 'fetchNotificationsAll', params: {'filter[special]': 'system'}},

            //{name: 'fetchEvents4Date', params: {date: 'today', withAddress: 1}},
            //{name: 'fetchVideoEvents4Date', params: {date: 'today', withAddress: 1}},
            //{name: 'fetchNotificationsEvents4Date', params: {date: 'today', withAddress: 1}},

            //{name: 'fetchVideoRequests4Date', params: {date: 'today', withAddress: 1}},
            //{name: 'fetchAccidents4Date', params: {date: 'today', withAddress: 1}},

            {name: 'fetchTrandataDmsAll', params: {}},

            {name: 'fetchSensorsAll', params: {}},
        ],
    },
    reloadAppProps: {
        dispatches: [
            {name: 'reloadUnitsAll', params: {}},
            {name: 'reloadUnitsLmsgsAll', params: {withAddress: 1}},
            {name: 'reloadVideoStatusesAll', params: {}},
            //{name: 'reloadDriversAll', params: {}},

            // {name: 'reloadGeopointsAll', params: {}},
            // {name: 'reloadGeozonesAll', params: {}},

            // {name: 'reloadNotificationsAll', params: {}},

            // {name: 'reloadEvents', params: {withAddress: 1}},
            // {name: 'reloadVideoEvents', params: {withAddress: 1}},
            // {name: 'reloadNotificationsEvents', params: {withAddress: 1}},
        ],
        commits: [
            {name: 'clearTrips', params: {}},
            {name: 'clearParkings', params: {}},
            {name: 'clearTracks', params: {}},

            {name: 'clearEvents', params: {}},
            {name: 'clearVideoEvents', params: {}},
            {name: 'clearNotificationsEvents', params: {}},
            {name: 'clearStops', params: {}},

            {name: 'clearVideoRequests', params: {}},
            {name: 'clearVideoRecords', params: {}},
        ],
    },
    fetchByTimer: {
        dispatches: [
            //{name: 'fetchAppUserChanged', eachT: 30, params: {}},

            {name: 'fetchUnitsChanged', eachT: 30, params: {}},
            {name: 'fetchUnitsLmsgsChanged', eachT: 15, params: {withAddress: 1, withSensors: 1}},//'filter[changed]': 60,
            {name: 'fetchVideoStatusesChanged', eachT: 30, params: {}},

            {name: 'fetchUnitsGroupsChanged', eachT: 30, params: {}},

            {name: 'fetchUsersChanged', eachT: 30, params: {}},
            {name: 'fetchUsersCustomizesChanged', eachT: 30, params: {}},
            {name: 'fetchUserFavoritesAndObjects', eachT: 30, params: {}},
            {name: 'fetchOrchestratorAppUser', eachT: 300, params: {}},
            //{name: 'fetchUserCustomize', eachT: 30, params: {appUser: true}},

            {name: 'fetchGeopointsChanged', eachT: 30, params: {}},
            {name: 'fetchGeozonesChanged', eachT: 30, params: {}},

            {name: 'fetchGeopointsGroupsChanged', eachT: 30, params: {}},
            {name: 'fetchGeozonesGroupsChanged', eachT: 30, params: {}},

            //{name: 'fetchNotificationsChanged', eachT: 30, params: {}},
            {name: 'fetchNotificationsChanged', eachT: 30, params: {'filter[special]': 'system'}},

            //{name: 'fetchEventsChanged', eachT: 30, params: {withAddress: 1}},
            //{name: 'fetchLastEvents', eachT: 30, params: {last: '15 minutes', withAddress: 1}},
            //{name: 'fetchLastVideoEvents', eachT: 30, params: {last: '15 minutes', withAddress: 1}},
            //{name: 'fetchLastNotificationsEvents', eachT: 30, params: {last: '15 minutes', withAddress: 1}},

            //{name: 'fetchVideoRequestsChanged', eachT: 30, params: {withAddress: 1}},
            //{name: 'fetchAccidentsChanged', eachT: 30, params: {}},
            {name: 'fetchAppointmentsChanged', eachT: 30, params: {}},
            {name: 'fetchDriversChanged', eachT: 30, params: {}},
            {name: 'fetchSensorsChanged', eachT: 30, params: {}},
            {name: 'fetchInsuranceReportsChanged', eachT: 30, params: {}},

            {name: 'fetchTrandataDmsChanged', eachT: 30, params: {}},
        ],
    },
    api: {
        user: {
            //fields: [],
            expand: ['units_of_measure', 'settings', 'notifications_settings', 'is_admin', 'is_super_admin',
                'parents', 'dealer_apikeys', 'dealers_apikeys', 'hide_menu', 'head__logo', 'dealer_login_logo',
                'map_apikeys', 'shifts', 'is_xroute', 'orchestrator', 'following_time'
            ],
        },

        unit_ext_services: {
            fields: ['id',],//!!!no changed__time
            expand: ['ext-services'],
        },
        units_lite: {
            fields: ['id', 'hw_type', 'name','parent__id', 'video'],//,'icon','icon_color','icon_halo'
            expand: [], //'access_right','user_creator', counters
        },
        units: {
            //fields: ['id','hw_type','hw_id','name','type','unit_icon','icon','max_speed','phone'],
            expand: ['user_creator', 'access_right', 'drivers', 'dimensions', 'axle_count', 'truck_type', 'cameras', 'camera_time_zone'], //,counters, 'video'
        },

        sensors: {
            fields: ['id', 'id_unit', 'type', 'name', 'msg_param', 'conversion', 'measure', 'units_of_measure', 'round', 'enum', 'is_visible', 'options', 'changed__time'],
        },

        drivers_lite: {
            fields: ['id','name'],
            expand: [], //,counters, 'video'
        },
        drivers: {
            //fields: ['id','name'],
            expand: ['documents', 'access_right', 'DriverApp', 'xRouteArgus'], //,counters, 'video'
        },
        drivers_groups: {
            //fields: [],
            expand: ['access_right'],//'user_creator'
        },

        appointments_lite: {
            fields: ['id', 'driver_id', 'unit_id', 'object_id', 'time_appointment', 'time_removed', 'employee_type'],
            expand: [], //,counters, 'video'
        },
        appointments: {
            //fields: ['id', 'id_units', 'id_driver'],
            expand: [], //,counters, 'video'
        },

        trandataDms: {
            //fields: [],//
            expand: ['pickup_address', 'delivery_address'],
        },

        units_groups_lite: {
            fields: ['id', 'name', 'icon'],
            expand: [],
        },
        units_groups: {
            // fields: ['id',],
            expand: ['access_right'],
        },

        unitslmsgs_lite: {
            fields: ['object_id', 'unit_id', 'id_unit', 'time', 'latlng', 'lbs_location', 'timeAgo'],
            //expand: [],
        },
        unitslmsgs: {
            // fields: ['object_id'],
            expand: ['access_right'],
        },

        users_lite: {
            fields: ['id','creator','login','email','phone','status','status_text'],
            //expand: [],
        },
        users: {
            fields: ['id','creator','login','email','phone','legal_name','time_zone','dst','status','status_text'],
            expand: ['user_creator', 'is_admin', 'is_super_admin', 'drivers'],
        },

        customizes_lite:{
            fields: ['id_user','user_id','url','dns','site_name','support_email','domains','changed__time'],
            expand: [],
        },
        customizes:{
            //fields: ['id_user','user_id','url','dns','site_name','support_email','domains','changed__time'],
            expand: [],
        },

        geopoints_lite: {
            fields: ['id', 'name', 'lat', 'lon', 'icon'],
            // expand: [],
        },
        geopoints: {
            //fields: ['id', 'name', 'descr', 'color', 'line', 'perimeter', 'radius', 'surface_area', 'docs_surface_area', 'maxSpeed'],
            expand: ['access_right'],
        },

        geopoints_groups_lite: {
            fields: ['id', 'name', 'geopoints'],
            // expand: [],
        },
        geopoints_groups: {
            //fields: ['id', 'name', 'descr', 'color', 'line', 'perimeter', 'radius', 'surface_area', 'docs_surface_area', 'maxSpeed'],
            expand: ['access_right'],
        },

        geozones_lite: {
            fields: ['id', 'name', 'color', 'line', 'perimeter', 'radius', 'surface_area', 'docs_surface_area', 'maxSpeed'],
            // expand: [],
        },
        geozones: {
            //fields: ['id', 'name', 'descr', 'color', 'line', 'perimeter', 'radius', 'surface_area', 'docs_surface_area', 'maxSpeed'],
            expand: ['access_right','points'],
        },

        geozones_groups_lite: {
            fields: ['id', 'name', 'geozones'],
            // expand: [],
        },
        geozones_groups: {
            //fields: ['id', 'name', 'descr', 'color', 'line', 'perimeter', 'radius', 'surface_area', 'docs_surface_area', 'maxSpeed'],
            expand: ['access_right'],
        },

        notifications: {
            //fields: [],
            expand: ['units', 'units-groups', 'geozones', 'geopoints'],
        },
        notifications_lite: {
            //fields: [],
            expand: ['units', 'units-groups', 'geozones', 'geopoints'],
        },

        template_reports: {
            //fields: [],
            expand: ['access_right'],//'user_creator'
        },
        services: {
            //fields: [],
            expand: ['access_right'],//'user_creator'
        },

        insurance_reports: {
            //fields: [],
            expand: ['form_items', 'form_values'],
        },
        insurance_reports_lite: {
            //fields: [],
            //expand: [],
        },

        units_msgs: {
            // fields: ['id',],
            expand: [],
        },

        events: {
            //fields: [],
            expand: [],
        },
        events_lite: {
            //fields: [],
            expand: [],
        },
        greenseeEvents: {
            //fields: [],
            //expand: [],
        },
        video_events: {
            //fields: [],
            expand: [],
        },
        video_events_lite: {
            //fields: [],
            expand: [],
        },
        video_requests: {
            //fields: [],
            expand: ['image'],
        },
        accidents: {
            //fields: [],
            expand: ['image', 'weather'],
        },
        video_requests_lite: {
            //fields: [],
            expand: [],
        },
        video_records: {
            //fields: [],
            expand: [],
        },
        video_records_lite: {
            //fields: [],
            expand: [],
        },
        video_status: {
            //fields: [],
            expand: ['errors'],
        },

        locator_units: {
            //fields: [],
            expand: [],
        },

        maintenance_vendors: {
            //fields: [],
            expand: ['access_right'],
        },

        reportsSchedulers: {
            //fields: [],
            expand: ['date__time'],
        },

        xRoutes: {
            //fields: [],
            expand: [],
        },
        xRoutesCalculated: {
            //fields: [],
            expand: ['assigned__time', 'accepted__time', 'started__time', 'completed__time'],
        },
        xRoutesWaypoints: {
            //fields: [],
            expand: [],
        }

    },
    components: {
        UnitEdit: {
            defaults: {
                options: {
                    components: [
                        'UnitEdit_Options_prometheus',
                        'UnitEdit_Characteristics',
                        'UnitEdit_Icon_prometheus',
                        'UnitEdit_AddInfo_prometheus',
                        'UnitEdit_Sensors_prometheus',
                        'UnitEdit_Camera_prometheus',
                        'UnitEdit_Properties_prometheus',
                        'UnitEdit_TPMS_prometheus',
                    ]
                }
            },
            xCargoUnit: {
                options: {
                    components: [
                        'UnitEdit_Options_intuit',
                        'UnitEdit_Delivery',
                        'UnitEdit_xCargoSensors',
                    ]
                }
            },
        },
        UserEdit: {
            defaults: {
                options: {
                    components: [
                        //'UserEdit_Options_intuit',
                        'UserEdit_Customize_prometheus',
                        //'UserEdit_Menus',
                        //'UserEdit_Api_intuit',
                        //'UserEdit_Units_list',
                        // 'UserEdit_Menus' ??
                    ]
                }
            }
        },
    },
    unitHwTypeTransformationToRoute: {
        pro_cargo_vision: {
            template: 'pro_cargo_vision',
        },
        philips: {
            template: 'pro_cargo_vision'
        },
        anytrek_vision: {
            template: 'pro_cargo_vision'
        },
        m2m: {
            template: 'm2m',
            type: {
                chassis: 'm2m_chassis',
            }
        },
        //digital_matter: 'xbles',
        //kkm_mqtt: 'xbles',
        xtag: {
            template: 'xbles'
        },
        thermoking: {
            template: 'xcool'
        }
    },
    unitTypeTransformationToRoute: {
        ble_gateway: 'xbles',
    },
    timelineComponentByRouteTemplate: {
        pro_cargo_vision: 'TimelineWrap_pro_cargo_vision',
        xbles: 'TimelineWrap_xbles',
        xcool: 'TimelineWrap_xcool',
        m2m: 'TimelineWrap_M2M',
        m2m_chassis: 'TimelineWrap_M2M',
    },
    notificationEventTypes: {
        cameraEventSubTypes,
        videoEventTypes,
        otherEventTypes,
    },
}

export default consts